// Typelizer digest a4622070eb68bcb6318e5ffb85979ff7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /communes */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/communes', {}, options),
    method: 'get',
  }),

  /** POST /communes */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/communes', {}, options),
    method: 'post',
  }),

  /** GET /communes/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/communes/new', {}, options),
    method: 'get',
  }),

  /** GET /communes/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/communes/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /communes/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/communes/:id', params, options),
    method: 'get',
  }),

  /** PATCH /communes/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/communes/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /communes/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/communes/:id', params, options),
    method: 'delete',
  }),
}
